__turbopack_context__.v({
  "featured_news_row": "FeaturedNewsRow-module-scss-module__UMHI2a__featured_news_row",
  "featured_news_row_splide_arrow": "FeaturedNewsRow-module-scss-module__UMHI2a__featured_news_row_splide_arrow",
  "featured_news_row_title": "FeaturedNewsRow-module-scss-module__UMHI2a__featured_news_row_title",
});
